import { PaymentMethod } from '../../interfaces';
import { APPLE_PAY, GOOGLE_PAY, SAMSUNG_PAY } from '../methods';

export const DIGITAL_PAYMENT_METHOD_GROUP: Array<PaymentMethod> = [
    APPLE_PAY,
    GOOGLE_PAY,
    SAMSUNG_PAY
];
